'use client'

import React from 'react'

import CodeConverterLayout from '../CodeConverterLayout'
import convertJSObjectToJSON from './convertJSObjectToJSON'


export default function JSObjectToJSONConverter() {
  return (
    <CodeConverterLayout
      inputLang={'js'}
      outputLang={'json'}
      convert={convertJSObjectToJSON}
    />
  )
}


